import queryString from 'query-string'
import React from 'react'
import { useSelector } from 'react-redux'
import { Rdrct } from 'src/navigation/Lnk'
import { expensesTransactionsUrl, myWalletTransactionsURL } from 'src/navigation/urls'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

interface TransactionsProps {
  yourTransactions?: boolean
}

const Transactions: React.FC<TransactionsProps> = (
  props,
) => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  return (
    <Rdrct
      to={{
        pathname: props.yourTransactions ? myWalletTransactionsURL() : expensesTransactionsUrl(),
        state: {},
        search: queryString.stringify({
          ...queryString.parse(calculatedBackgroundLocation.search),
        }),
        hash: '',
      }}
    />
  )
}

export default Transactions
